import React from 'react';
import * as PropTypes from 'prop-types';
import CustomLink from '../../UI/CustomLink';
import helpers from '../../../helpers/helpers';
import { STATIC_PREFIX } from '../../../constants/staticPrefix';
import styles from './AdvertListItem.module.scss';
import IconTrash from '../../UI/Icons/IconTrash';

const AdvertListItem = ({ product, onDelete }) => {
  const { getTranslationText } = helpers;

  const handleDelete = (e) => {
    onDelete(product.id);
  };

  return (
    <div className={styles.item}>
      <div
        className={styles.itemImg}
        style={
          product.preview.thumb
            ? { backgroundImage: `url(${product.preview.thumb}` }
            : { backgroundImage: `url(${STATIC_PREFIX}/static/images/logo.png)`, backgroundSize: '200px' }
        }
      />
      {/*<div className="advert-list-item__data">*/}
      {/*  <span className="advert-list-item__city">{product.location ? product.location.city.name : null}</span>*/}
      {/*  <span className="advert-list-item__views">*/}
      {/*    {product.visits}*/}
      {/*    {' '}*/}
      {/*    {getTranslationText('card.views')}*/}
      {/*  </span>*/}
      {/*</div>*/}
      <h2 className={styles.itemTitle}>{product.title}</h2>
      <p className={styles.itemOwner}>
        <span>{getTranslationText('general.owned') || 'Owned by'}</span>&nbsp;
        <CustomLink
          href="/[username]"
          as={`/${product.user.username}`}
        >
          <span className={styles.itemUsername}>
            {product.user.username}
          </span>
        </CustomLink>
      </p>
      {/*<div className="advert-list-item__data">*/}
      {/*  <div className="advert-list-item__stars">*/}
      {/*    <ReactStars*/}
      {/*      count={5}*/}
      {/*      size={16}*/}
      {/*      color2="#ffd700"*/}
      {/*      value={product.user.rating}*/}
      {/*      edit={false}*/}
      {/*    />*/}
      {/*    {' '}*/}
      {/*    <span>{product.user.rating}</span>*/}
      {/*  </div>*/}
      {/*</div>*/}
      <div className={styles.itemFooter}>
        <div className={styles.itemBtn}>
          <span>
            {/* eslint-disable-next-line no-nested-ternary */}
            {(product.type === 0)
              ? product?.price?.price
              : (product.auction_bids?.filter((el) => el.active)[0]?.bid
                ? product.auction_bids?.filter((el) => el.active)[0]?.bid
                : product?.price?.price)}
            &nbsp;
            {product?.price?.name}
          </span>
          <span>
            {getTranslationText('general.buy') || 'Купить'}
          </span>
        </div>
        {typeof onDelete === 'function' && (
          <button className={styles.itemDelete} onClick={handleDelete}>
            <IconTrash />
          </button>
        )}
      </div>
      <CustomLink
        href="/[username]/[id]"
        as={`/${product.user.username}/${product.link}`}
        className={styles.itemLink}
      >
        <React.Fragment />
      </CustomLink>
    </div>
  );
};

AdvertListItem.propTypes = {
  product: PropTypes.object.isRequired,
};

export default AdvertListItem;
